
import React from 'react';

/**
 * Gemini API Coding Guidelines:
 * - The application must not ask the user for an API key under any circumstances.
 * - The API key must be obtained exclusively from the environment variable process.env.API_KEY.
 * - Do not generate any UI elements (input fields, forms, prompts) for entering or managing the API key.
 */
interface ApiKeyGuardProps {
  children: React.ReactNode;
}

const ApiKeyGuard: React.FC<ApiKeyGuardProps> = ({ children }) => {
  // Assume process.env.API_KEY is pre-configured and valid.
  // The setup UI is removed to strictly follow security and architectural guidelines.
  return <>{children}</>;
};

export default ApiKeyGuard;
